import { t as tr } from "../../../i18n";
import type { CaseId, Force, WallResult } from "@tasduvar/engine";
import { fmt } from "@tasduvar/engine";
import { toSvg, type Transform } from "../geometry";
import { useHighlight } from "../../../state/highlight";
import { FORCE_COLOR as COLOR } from "../forceColors";

function Arrow({ f, t, maxF, hl }: { f: Force; t: Transform; maxF: number; hl: boolean }): JSX.Element {
  const p = toSvg(t, { x: f.x, y: f.y });
  const parts: { dir: "v" | "h"; x1: number; y1: number; x2: number; y2: number }[] = [];
  const len = (F: number): number => 12 + 40 * Math.min(1, Math.abs(F) / maxF);
  if (Math.abs(f.V) > 1e-9) { const L = len(f.V); parts.push(f.V > 0 ? { dir: "v", x1: p.x, y1: p.y - L, x2: p.x, y2: p.y } : { dir: "v", x1: p.x, y1: p.y + L, x2: p.x, y2: p.y }); }
  if (Math.abs(f.H) > 1e-9) { const L = len(f.H); parts.push(f.H > 0 ? { dir: "h", x1: p.x + L, y1: p.y, x2: p.x, y2: p.y } : { dir: "h", x1: p.x - L, y1: p.y, x2: p.x, y2: p.y }); }
  const color = COLOR[f.kind];
  return (
    <g data-force={f.id} data-kind={f.kind} data-highlight={hl ? "true" : undefined} opacity={hl ? 1 : 0.85}>
      {parts.map(({ dir, ...s }, i) => <line key={i} data-dir={dir} {...s} stroke={color} strokeWidth={hl ? 3 : 1.6} markerEnd="url(#arrowF)" />)}
      <circle cx={p.x} cy={p.y} r={hl ? 3.5 : 2} fill={color} />
      {hl ? <text x={p.x + 6} y={p.y - 6} className="text-[10px] num" fill={color}>{f.id}: V {fmt(f.V, 1)} · H {fmt(f.H, 1)} {tr("kN/m")}</text> : null}
    </g>
  );
}

export function Forces({ t, result, caseId }: { t: Transform; result: WallResult; caseId: CaseId }): JSX.Element | null {
  const hl = useHighlight((s) => s.forceId);
  const c = result.cases[caseId]; if (!c) return null;
  const maxF = Math.max(1e-9, ...c.forces.map((f) => Math.max(Math.abs(f.V), Math.abs(f.H))));
  return <g>{c.forces.map((f) => <Arrow key={f.id} f={f} t={t} maxF={maxF} hl={hl === f.id} />)}</g>;
}
